import { cloneDeep, get, set } from "lodash";
import {
  DEPARTMENTS,
  INSURANCE_PLAN_PARAMS_RULES,
  JOB_LIST,
  LMF_ASSOCIATION_MEMBER_TYPE,
  PROFILE_LIST,
  SOCIAL_REGIMES,
} from "utils/constants";

export const buildExcludeRuleKey = (paramIndex, ruleName) =>
  `${paramIndex}.${ruleName}`;

export const STATIC_RULE_ALL_VALUES = {
  [INSURANCE_PLAN_PARAMS_RULES.SOCIAL_REGIMES]: () =>
    Object.values(SOCIAL_REGIMES),
  [INSURANCE_PLAN_PARAMS_RULES.PROFESSION]: () => Object.values(JOB_LIST),
  [INSURANCE_PLAN_PARAMS_RULES.PROFILES]: () => Object.values(PROFILE_LIST),
  [INSURANCE_PLAN_PARAMS_RULES.SUB_PROFILES]: () =>
    Object.values(LMF_ASSOCIATION_MEMBER_TYPE),
  [INSURANCE_PLAN_PARAMS_RULES.DEPARTMENTS]: () => DEPARTMENTS,
};

export const getStaticRuleAllValues = (ruleName) => {
  const resolver = STATIC_RULE_ALL_VALUES[ruleName];
  return resolver ? resolver() : null;
};

export const applyExcludeTransformToParams = (
  params,
  excludeFlags,
  dynamicAllValues = {},
) => {
  if (!params?.length) {
    return params;
  }

  return params.map((param, paramIndex) => {
    const rules = cloneDeep(param.rules || {});

    Object.entries(excludeFlags).forEach(([key, isExcluded]) => {
      if (!isExcluded) {
        return;
      }

      const [indexStr, ruleName] = key.split(".");
      if (Number(indexStr) !== paramIndex) {
        return;
      }

      const allValues =
        dynamicAllValues[key] || getStaticRuleAllValues(ruleName);
      if (!allValues?.length) {
        return;
      }

      const selectedValues = get(rules, `${ruleName}.value`, []) || [];
      const includedValues = allValues.filter(
        (value) => !selectedValues.includes(value),
      );

      set(rules, `${ruleName}.value`, includedValues);
    });

    return { ...param, rules };
  });
};
